module.exports = __webpack_public_path__ + "07_mole.dc81f352.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer2/07_mole.png
// module id = /1bp
// module chunks = 0